/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProceedingParticipantType } from './ProceedingParticipantType';
import {
    ProceedingParticipantTypeFromJSON,
    ProceedingParticipantTypeFromJSONTyped,
    ProceedingParticipantTypeToJSON,
    ProceedingParticipantTypeToJSONTyped,
} from './ProceedingParticipantType';

/**
 * 
 * @export
 * @interface ProceedingParticipantSearchResult
 */
export interface ProceedingParticipantSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    proceedingParticipantId: string;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    name: string;
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof ProceedingParticipantSearchResult
     */
    type: ProceedingParticipantType;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    country: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantSearchResult
     */
    isClientSpecific: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantSearchResult
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantSearchResult
     */
    deactivatedAtUtc: Date | null;
}



/**
 * Check if a given object implements the ProceedingParticipantSearchResult interface.
 */
export function instanceOfProceedingParticipantSearchResult(value: object): value is ProceedingParticipantSearchResult {
    if (!('proceedingParticipantId' in value) || value['proceedingParticipantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('isClientSpecific' in value) || value['isClientSpecific'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('deactivatedAtUtc' in value) || value['deactivatedAtUtc'] === undefined) return false;
    return true;
}

export function ProceedingParticipantSearchResultFromJSON(json: any): ProceedingParticipantSearchResult {
    return ProceedingParticipantSearchResultFromJSONTyped(json, false);
}

export function ProceedingParticipantSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProceedingParticipantSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'proceedingParticipantId': json['proceedingParticipantId'],
        'name': json['name'],
        'type': ProceedingParticipantTypeFromJSON(json['type']),
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'isClientSpecific': json['isClientSpecific'],
        'isActive': json['isActive'],
        'deactivatedAtUtc': (json['deactivatedAtUtc'] == null ? null : new Date(json['deactivatedAtUtc'])),
    };
}

export function ProceedingParticipantSearchResultToJSON(json: any): ProceedingParticipantSearchResult {
    return ProceedingParticipantSearchResultToJSONTyped(json, false);
}

export function ProceedingParticipantSearchResultToJSONTyped(value?: ProceedingParticipantSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proceedingParticipantId': value['proceedingParticipantId'],
        'name': value['name'],
        'type': ProceedingParticipantTypeToJSON(value['type']),
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'isClientSpecific': value['isClientSpecific'],
        'isActive': value['isActive'],
        'deactivatedAtUtc': value['deactivatedAtUtc'] == null ? value['deactivatedAtUtc'] : value['deactivatedAtUtc'].toISOString(),
    };
}

